const domain = {
    not_configured: '域名主機供應商未設定。',
    cloudflare_data_missing: 'cloudflare_data缺失，請檢查。',
    cloudflare_unknown_error: '獲取Cloudflare介面時發生未知錯誤',
    cloudflare_response_error: '從Cloudflare獲取到意外的響應',
    limit_to_one_domain: '你只能擁有一個自訂域名。',
    hostname_already_exists: '此域名已存在於我們的伺服器中。',
    cloudflare_not_found: '無法在Cloudflare中找到主機名',
    domain_is_not_allowed: '這個域名不被允許。',
    domain_in_use: '域名 {{domain}} 已被使用。',
    exceed_domain_limit: '你最多可以擁有 {{limit}} 個自訂域名。',
};
export default Object.freeze(domain);
